<template>
  <div class="plant-wrapper">
    <div class="plant-wrapper-top">
      <div class="handle-wrapper" @click="backPath"><div class="icon-font">&#xe612;</div>返回</div>
      <div class="plant-wrapper-top-title">虫情杀虫审批</div>
      <div class="handle-wrapper" @click="handleData"><div class="icon-font">&#xe653;</div>提交</div>
    </div>
    <div class="plant-deal-content" v-if="loading">
      <div class="loading-data">
        <i class="el-icon-loading"></i>
        <div>加载中，请稍后···</div>
      </div>
    </div>
    <div class="plant-deal-content" v-if="!loading">
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-title">申请编号：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.applyNum"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">仓库位置：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.siteName"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title" style="padding-left: 0.83vw">负责人：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.principalName"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">制单人：</div>
          <div class="input-wrapper" style="margin-right: 0">
            <input disabled="true" v-model="inputValue.createdUser"/>
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-title">制单日期：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.createdTime"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">杀虫日期：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.killPestTime"/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">完成日期：</div>
          <div class="input-wrapper">
            <input disabled="true" v-model="inputValue.finishTime"/>
          </div>
        </div>
        <div class="input-contain" style="opacity: 0">
          <div class="input-title">请编号：</div>
          <div class="input-wrapper" style="margin-right: 0"></div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="wrapper-title">
          <div>杀虫方式：</div>
          <div class="text-wrapper">
            {{inputValue.killPestType}}
          </div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="input-contain">
          <div class="input-title">垛位状态：</div>
          <div class="input-wrapper">{{inputValue.stackStatus === '01' ? '需杀虫' : '正常养护'}}</div>
        </div>
      </div>
      <div class="plant-deal-content-wrapper" style="z-index: 7" v-if="inputValue.stackStatus === '01'">
        <div class="input-contain" style="margin-right: 1vw">
          <div class="input-title" style="padding-left: 0.83vw">处理人：</div>
          <DropDownInput type="1" :items="custodianValue" :content="inputValue.handlerName" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
        </div>
      </div>
      <div class="plant-deal-content-wrapper">
        <div class="wrapper-title">
          <div style="padding-left: 1.8vw">备注：</div>
          <div class="text-wrapper">
            <label>
              <textarea v-model="inputValue.remark" rows="5"></textarea>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {applyInfo, handleCheck} from '../../../api/maintain'
import {renderTime, noEmpty} from '../../../tools/methods'
import {userList} from '../../../api/system'
import DropDownInput from '../../../components/DropDownInput.vue'
import DropDown from '../../../components/DropDownSingle.vue'
export default {
  name: 'AuditPlant',
  components: { DropDownInput, DropDown },
  data () {
    return {
      loading: true,
      inputValue: {
        id: '',
        applyNum: '',
        finishTime: '',
        handlerName: '',
        killPestTime: '',
        killPestType: '',
        principalName: '',
        siteName: '',
        stackStatus: '',
        createdUser: '',
        createdTime: '',
        handlerId: '',
        remark: ''
      },
      stackData: [
        {name: '需杀虫', value: '01'},
        {name: '正常养护', value: '02'}
      ],
      custodianValue: []
    }
  },
  created () {
    let body = {
      pestDetailId: this.$route.query.pestDetailId,
      requestType: '02'
    }
    applyInfo(body).then(res => {
      console.log(res)
      res.data.killPestTime = res.data.killPestTime ? renderTime(res.data.killPestTime) : '--'
      res.data.finishTime = res.data.finishTime ? renderTime(res.data.finishTime) : '--'
      res.data.createdTime = res.data.createdTime ? renderTime(res.data.createdTime) : '--'
      this.inputValue = {
        id: res.data.id,
        pestDetailId: res.data.pestDetailId,
        applyNum: res.data.applyNum,
        finishTime: res.data.finishTime,
        handlerName: res.data.principalName,
        killPestTime: res.data.killPestTime,
        killPestType: res.data.killPestType,
        principalName: res.data.principalName,
        stackStatus: res.data.stackStatus,
        siteName: res.data.siteName,
        createdUser: res.data.createdUser,
        createdTime: res.data.createdTime,
        handlerId: res.data.principalId,
        remark: ''
      }
      this.loading = false
    }).catch(err => {
      console.log(err)
    })
    this.handleSearchValue()
  },
  methods: {
    backPath: function () {
      this.$router.go(-1)
    },
    showInfo: function (data) {
      this.inputValue.handlerId = data.id
      this.inputValue.handlerName = data.name
    },
    showInfoStack: function (data) {
      this.inputValue.stackStatus = data.value
    },
    sendValue: function (value) {
      this.handleSearchValue(value)
    },
    handleSearchValue: function (value) {
      let body = {
        keywork: value,
        page: 1,
        rows: 9999
      }
      userList(body).then(res => {
        console.log(res)
        this.custodianValue = res.data.rows
      }).catch(err => {
        console.log(err)
      })
    },
    handleData: function () {
      let body
      if (noEmpty(this.inputValue.stackStatus, '请选择垛位状态', '')) {
        if (this.have) {
          if (noEmpty(this.inputValue.handlerId, '请选择处理人员', '')) {
            body = {
              id: this.inputValue.id,
              pestDetailId: this.inputValue.pestDetailId,
              applyNum: this.inputValue.applyNum,
              handlerId: this.inputValue.handlerId,
              handlerName: this.inputValue.handlerName,
              stackStatus: this.inputValue.stackStatus,
              remark: this.inputValue.remark
            }
          }
        } else {
          body = {
            id: this.inputValue.id,
            pestDetailId: this.inputValue.pestDetailId,
            applyNum: this.inputValue.applyNum,
            stackStatus: this.inputValue.stackStatus,
            remark: this.inputValue.remark
          }
        }
        handleCheck(body).then(res => {
          console.log(res)
          if (res.code === 500) {
            this.$message({
              message: res.data,
              type: 'warning',
              center: 'true',
              duration: '1000'
            })
          } else {
            this.$message({
              message: res.data,
              type: 'success',
              center: 'true',
              duration: '1000'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style scoped>
  @import "Plant.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/plant/AuditPlant.vue